import styles from './TransformChipStack.module.css';

interface ChainStep {
  type: string;
  config: Record<string, unknown>;
}

interface Props {
  chain: ChainStep[];
  onEdit: () => void;
}

const VISIBLE_CHIPS = 4;

export function TransformChipStack({ chain, onEdit }: Props) {
  if (chain.length === 0) {
    return (
      <button type="button" className={styles.addLink} onClick={onEdit}>
        Add transforms
      </button>
    );
  }

  const visible = chain.slice(0, VISIBLE_CHIPS);
  const overflow = chain.length - VISIBLE_CHIPS;

  return (
    <div className={styles.row}>
      <div className={styles.chips}>
        {visible.map((step, i) => (
          <span key={i} className={styles.chip} data-testid="transform-chip">
            {step.type}
          </span>
        ))}
        {overflow > 0 && (
          <span className={styles.overflow}>+{overflow} more</span>
        )}
      </div>
      <button type="button" className={styles.editButton} onClick={onEdit}>
        Edit
      </button>
    </div>
  );
}
